import { useMemo } from 'react';
import { getConditionalPropertyDependencies } from './utils';
const useConditionalPropertyDependencies = ({
  loading,
  error,
  objectTypeId,
  conditionalPropertyRules,
  getFormValue,
  properties,
  changedProperties,
  enableAutosave
}) => {
  return useMemo(() => {
    if (!loading && !error) {
      return getConditionalPropertyDependencies(objectTypeId, getFormValue, properties, conditionalPropertyRules, changedProperties, enableAutosave);
    }
    return {};
  }, [conditionalPropertyRules, error, getFormValue, loading, objectTypeId, properties, changedProperties, enableAutosave]);
};
export default useConditionalPropertyDependencies;